/* istanbul ignore file */
import React from 'react';
import { CheckboxGroupLayoutProps, Text } from 'ui-builder';
import { cn } from 'shadcn-ui';
import Label from '../form/layout/Label';
import RelativeRow from '../../web/uitheme/form/RelativeRow';
import ErrorsWrapper from '../form/input/layout/ErrorsWrapper';
import Checkbox from '../form/input/Checkbox';

export default function ShadcnCheckboxGroupLayout(
  props: CheckboxGroupLayoutProps<any>,
) {
  const checkboxes = props.options.map((option) => {
    const itemSource = `${props.name}.${option.value}`;

    return (
      <Checkbox
        hint={option.hint}
        source={itemSource}
        label={option.label}
        key={`value-${option.value}`}
        value={props.isSelectedFunc(option.value)}
        isHighlighted={option.isHighlighted}
        isDisabled={props.isDisabled}
        onChangeCallback={(data) => {
          if (data[itemSource]) {
            props.selectFunc(option.value);
          } else {
            props.unselectFunc(option.value);
          }
        }}
      />
    );
  });

  return (
    <ErrorsWrapper name={props.name}>
      <div className={props.className}>
        {!props.hideLabel && (
          <Label label={props.label} bold={props.boldLabel} className={props.labelClassName} />
        )}
        {checkboxes.length ? (
          <div className={cn('flex flex-col gap-2', props.optionsContainerClassName)}>
            <RelativeRow weights={props.weights || []}>
              {checkboxes}
            </RelativeRow>
          </div>
        ) : (
          <Text className="gray-message">{props.noOptionsMessage}</Text>
        )}
        {props.hint && (
          <div className="text-xs text-muted-foreground mt-1">
            {props.hint}
          </div>
        )}
      </div>
    </ErrorsWrapper>
  );
}
